import React from 'react';
import { Navigate } from 'react-router-dom';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import awsConfig from '../aws-exports';

const poolData = {
  UserPoolId: awsConfig.userPoolId,
  ClientId: awsConfig.userPoolWebClientId,
};
const userPool = new CognitoUserPool(poolData);

function isAuthenticated() {
  const user = userPool.getCurrentUser();
  if (!user) return false;
  let valid = false;
  user.getSession((err, session) => {
    if (err || !session || !session.isValid()) valid = false;
    else valid = true;
  });
  return valid;
}

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
